"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("react-utils/debounce"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _link = require("../../constants/link");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var PageLinkField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PageLinkField, _Component);

  function PageLinkField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PageLinkField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageLinkField).call(this, props));
    _this.fetchPublishedContent = (0, _debounce.default)(_this.fetchPublishedContent.bind((0, _assertThisInitialized2.default)(_this)), 200);
    return _this;
  }

  (0, _createClass2.default)(PageLinkField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchPublishedContent",
    value: function fetchPublishedContent(input, callback) {
      var _this2 = this;

      var pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        offset: 0
      };
      var fetchPages = this.props.fetchPages;
      fetchPages(input, pagination.offset).then(function (data) {
        if (!_this2.mounted) {
          return;
        }

        var parsedData = data.objects.map(function (asset) {
          return {
            text: asset.name,
            value: asset.url,
            help: asset.url
          };
        });
        var fetchedPages = !data.offset ? parsedData : _this2.state.fetchedPages.concat(parsedData);

        _this2.setState({
          fetchedPages: fetchedPages
        });

        callback(null, {
          options: fetchedPages,
          pagination: {
            hasMore: data.offset + data.limit < data.totalCount,
            length: data.totalCount,
            offset: pagination.offset + 10
          }
        });
      }, function () {
        if (!_this2.mounted) {
          return;
        }

        _this2.setState({
          fetchError: true
        });

        callback(null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          onChange = _this$props.onChange,
          dropdownClassName = _this$props.dropdownClassName;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.PAGE + ".label")),
        className: "m-top-0"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        cache: false,
        loadOptions: this.fetchPublishedContent,
        filterOptions: false,
        value: url,
        onSelectedOptionChange: function onSelectedOptionChange(_ref) {
          var data = _ref.target.value;
          onChange({
            url: data.value,
            pageName: data.text
          });
        },
        placeholder: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.PAGE + ".placeholder"))
      }));
    }
  }]);
  return PageLinkField;
}(_react.Component);

exports.default = PageLinkField;
PageLinkField.propTypes = {
  url: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  fetchPages: _propTypes.default.func.isRequired,
  dropdownClassName: _propTypes.default.string
};
module.exports = exports.default;